<template>
	<div class="container">
		<div class="row">
			<div class="col-sm-6">
				<h2 class="text-uppercase">{{ render_project.title }}</h2>
				<p class="text-general text-height-md">
					{{{ transform(render_project.proyect_description) }}}
				</p>
			</div>
			<div class="col-sm-6">
				<carousel v-if="render_images.length" :sliders="render_images"></carousel>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12" v-if="render_products.length">
				<h2 class="text-uppercase products-in-use">Productos utilizados</h2>
				<div class="projects-container col-sm-3" v-for="product in render_products">
					<cards :product="product"></cards>
				</div>
			</div>

			<div v-if="!render_products.length" class="col-sm-12 empty">No hay productos utilizados en este proyecto.</div>
		</div>
	</div>
</template>

<style scoped>
	.col-sm-12{
		padding: 15px;
	}
	.products-in-use {
		padding: 15px;
	}
</style>

<script>
import Cards from '../components/Home/Card.vue';
import Carousel from '../components/Projects/Carousel.vue';
import Store from '../store/store';
import { setCurrentProject } from '../store/actions';

export default{
	// ---- DATA ----

	data () {
		return {};
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			project: state => state.current_project
		},
		actions: {
			setCurrentProject
		}
	},

	// ---- RENDER ----

	computed: {
		render_products () {
			return this.project.products || [];
		},

		render_project () {
			return this.project;
		},

		render_images () {
			return this.project.images;
		}
	},

	// ---- METHODS ----

	methods: {
		transform (text) {
			let new_text = '';

			if (text)
				for (let i = 0, t = text; i < text.length; i++) {
					if (t[i] == ';') {
						new_text += '<br/><br/>';
					} else {
						new_text += t[i];
					}
				}

			return new_text;
		}
	},

	// ---- COMPONENTS ----
	
	components: {
		Cards,
		Carousel,
	},

	// ---- READY ----

	ready () {
		$(".item-card-new").css({"top": "0", "right": "25px"});
		this.setCurrentProject(this.$route.params.id);
	}
}
</script>


// WEBPACK FOOTER //
// Projects-contract-interior.vue?46ab8d0e